import { useState, useCallback, useRef } from "react"
import useEventListener from "./useEventListener"

const useRemainWindowHeight = ({
    defaultHeight,
    deps = [],
    getElement = (rf) => rf,
    offset = 0,
    minHeight = 200,
    enabled = true
} = {}) => {
    const [height, setHeight] = useState(null)
    const elementRef = useRef()

    const computeHeight = useCallback(
        (element) => {
            setHeight(() => {
                let _height = defaultHeight

                if (element) {
                    const rect = element.getBoundingClientRect()
                    _height = window.innerHeight - rect.top - offset
                }

                if (_height < minHeight) {
                    _height = minHeight
                }

                return _height
            })
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [defaultHeight, minHeight, offset, ...deps]
    )

    useEventListener(
        "resize",
        () => {
            const element = getElement(elementRef.current)
            computeHeight(element)
        },
        {
            triggerOnMounted: true,
            element: enabled ? window : null
        }
    )

    return [elementRef, height]
}

export default useRemainWindowHeight
